import { render, staticRenderFns } from "./PageBuilderLayout.vue?vue&type=template&id=768ef1c4"
import script from "./PageBuilderLayout.vue?vue&type=script&lang=js"
export * from "./PageBuilderLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports